import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const footerLinks = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms & Conditions', to: '/terms-of-service' },
  { label: 'Refund & Return Policy', to: '/refund-policy' },
  { label: 'Shipping Policy', to: '/shipping-policy' },
  { label: 'Contact', to: '/contact' },
  { label: 'Email/SMS Marketing Terms', to: '/marketing-terms' },
];

export default function Footer() {
  const { pathname } = useLocation();

  if (pathname.startsWith('/admin')) return null;

  return (
    <footer className="border-t border-gray-200 bg-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {footerLinks.map((link, i) => (
          <React.Fragment key={link.to}>
            <Link
              to={link.to}
              className="text-xs text-gray-500 hover:text-gray-800 transition-colors whitespace-nowrap"
            >
              {link.label}
            </Link>
            {i < footerLinks.length - 1 && (
              <span className="text-gray-300 text-xs select-none hidden sm:inline">·</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </footer>
  );
}
